export type JsonPrimitive = string | number | boolean | null;
export type JsonValue = JsonPrimitive | JsonValue[] | { [key: string]: JsonValue };

export type UserSettings = Record<string, JsonValue>;
export type ChartLayout = Record<string, JsonValue>;

export const chartLayoutStorageKey = 'charts.tv.layout';
export const chartSettingsStorageKey = 'charts.tv.settings';
export const remoteLayoutKey = 'chart_layout';
export const remoteSettingsKey = 'chart_settings';
export const remoteChartStateKey = 'chart_state';
export const cloudSyncSettingKey = 'cloudSync';

export interface WatchlistItem {
  symbol: string;
  description?: string;
  exchange?: string;
}

export interface FavoriteItem {
  id: string;
  symbol: string;
  interval?: string;
  kind: 'symbol' | 'preset';
}

export interface AlertDraft {
  id: string;
  symbol: string;
  condition: 'above' | 'below';
  price: number;
  enabled: boolean;
}
